import { render, staticRenderFns } from "./OpenOrphanTaskModal.vue?vue&type=template&id=223aac59&scoped=true&class=fill-height&"
import script from "./OpenOrphanTaskModal.vue?vue&type=script&lang=ts&"
export * from "./OpenOrphanTaskModal.vue?vue&type=script&lang=ts&"
import style0 from "./OpenOrphanTaskModal.vue?vue&type=style&index=0&id=223aac59&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223aac59",
  null
  
)

export default component.exports